import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {
  BaseLoginComponent,
  PageType,
} from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-dr-dish',
  templateUrl: './dr-dish.component.html',
  styleUrls: ['../style/global.css', './dr-dish.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DrDishComponent extends BaseLoginComponent implements OnInit {
  @Input()
  clientId: string;

  password = '';
  firstName = '';
  lastName = '';

  inputState = {
    email: { isFocus: false },
    password: { isFocus: false },
    confirmPassword: { isFocus: false },
    firstName: { isFocus: false },
    lastName: { isFocus: false },
  };
  passwordState: 'text' | 'password' = 'password';

  page: PageType;

  titleMaps() {
    return {
      'forgot-password': 'パスワードを忘れた方 | Dr.Dish医療・栄養サポート™',
      'password-reset-send':
        'リセット用URLをメールで送信しました | Dr.Dish医療・栄養サポート™',
      login: 'ログイン | Dr.Dish医療・栄養サポート™',
      register: '新規登録 | Dr.Dish医療・栄養サポート™',
      'register-resend': '',
    };
  }

  async ngOnInit() {}

  focus(val: { isFocus: boolean }) {
    val.isFocus = true;
  }
  blur(val: { isFocus: boolean }) {
    val.isFocus = false;
  }

  get inputLabelClass() {
    if (this.email.length || this.inputState.email.isFocus)
      return 'v-label theme--light v-label--active primary--text';
    return 'v-label theme--light';
  }
  get passwordLabelClass() {
    if (this.password.length || this.inputState.password.isFocus)
      return 'v-label theme--light v-label--active primary--text';
    return 'v-label theme--light';
  }

  get confirmPasswordLabelClass() {
    if (this.confirmPassword.length || this.inputState.confirmPassword.isFocus)
      return 'v-label theme--light v-label--active primary--text';
    return 'v-label theme--light';
  }

  get givennameLabelClass() {
    if (this.firstName.length || this.inputState.firstName.isFocus)
      return 'v-label theme--light v-label--active primary--text';
    return 'v-label theme--light';
  }

  get familyNameLabelClass() {
    if (this.lastName.length || this.inputState.lastName.isFocus)
      return 'v-label theme--light v-label--active primary--text';
    return 'v-label theme--light';
  }

  get checkedStyle() {
    if (!this.acceptTerm) {
      return {
        i: `v-icon notranslate mdi mdi-checkbox-blank-outline theme--light`,
        div: `v-input--selection-controls__ripple`,
      };
    }
    return {
      i: `v-icon notranslate mdi mdi-checkbox-marked theme--light primary--text`,
      div: `v-input--selection-controls__ripple primary--text`,
    };
  }

  check() {
    this.acceptTerm = !this.acceptTerm;
  }

  /** 登録時のロール設定. フォームから指定する */
  protected registrationRole(): string {
    // TODO デザインに合わせて実装
    return undefined;
  }
}
